import { getStorage, ref, uploadBytes } from "firebase/storage";

export async function uploadFileToStorage(route, file) {
  const storage = getStorage();
  const storageRef = ref(storage, route);
  return await uploadBytes(storageRef, file);
}
